import React from "react"
// import calendar from "gatsby-background-image"
import BackgroundImage from "gatsby-background-image"
import { useStaticQuery, graphql } from "gatsby"

const BackgroundImageMain = ({ children, className }) => {
  const backgroundData = useStaticQuery(graphql`
    query BackgroundImageQuery {
      file(relativePath: { eq: "Vanessa-Nature Picture.JPG" }) {
        id
        childImageSharp {
          fluid(maxWidth: 1028) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  const fluidBackground = backgroundData.file.childImageSharp.fluid
  return <BackgroundImage fluid={fluidBackground}>{children}</BackgroundImage>
}

export default BackgroundImageMain
